<div class="modal-section">
  <div class="modal-section__header">
    <h2 class="typo-title-2-bolder">Cookie Settings</h2>
  </div>

  <div class="modal-section__body">
    <p class="modal-section__text">
      Our website uses cookies to ensure proper functionality and to enable
      wallet connections. Please review and accept the cookie categories below
      to continue.
    </p>

    <div class="cookie-option">
      <div class="cookie-option__row">
        <input
          type="checkbox"
          id="strictlyNecessary"
          class="cookie-checkbox"
          [checked]="true"
          [disabled]="true"
        />
        <label for="strictlyNecessary" class="cookie-option__label">
          Strictly Necessary Cookies
        </label>
      </div>
      <p class="cookie-option__desc">
        These cookies are essential for the website to function properly. They
        enable core functionality such as security, network management, and
        wallet authentication. These cookies cannot be disabled.
      </p>
    </div>

    <div class="cookie-option">
      <div class="cookie-option__row">
        <input
          type="checkbox"
          id="additionalCookies"
          class="cookie-checkbox"
          [checked]="additionalCookies()"
          (change)="additionalCookies.set($any($event.target).checked)"
        />
        <label for="additionalCookies" class="cookie-option__label">
          Additional Cookies
        </label>
      </div>
      <p class="cookie-option__desc">
        We'd like to set additional cookies to understand site usage, make site
        improvements, and to remember your settings.
      </p>
    </div>
  </div>

  <div class="modal-section__actions">
    <kc-button
      variant="primary"
      size="m"
      text="Accept"
      [isFullWidth]="true"
      (buttonClick)="accept()"
    />
    <kc-button
      variant="secondary"
      size="m"
      text="Cancel"
      [isFullWidth]="true"
      (buttonClick)="cancel()"
    />
  </div>
</div>
